module.exports = __webpack_public_path__ + "dist/assets/img/S.11cf34f0.svg";